<template>
    <div class="contact-form">
        <h2>
            {{ $translate('public.contact.form.title') }}
        </h2>
        <form>
            <div>
                <label for="first-name" class="required_label">{{
                    $translate('public.contact.form.first-name')
                }}</label>
                <input
                    type="text"
                    id="first-name"
                    v-model="userInfos.firstname"
                    :class="{
                        inputIsInvalid: apiStore.$state.errors.firstname,
                    }"
                />
            </div>
            <div>
                <label for="last-name" class="required_label">{{
                    $translate('public.contact.form.last-name')
                }}</label>
                <input
                    type="text"
                    id="last-name"
                    v-model="userInfos.lastname"
                    :class="{
                        inputIsInvalid: apiStore.$state.errors.lastname,
                    }"
                />
            </div>
            <div>
                <label for="company-name">{{
                    $translate('public.contact.form.cp-name')
                }}</label>
                <input
                    type="text"
                    id="company-name"
                    v-model="userInfos.companyName"
                />
            </div>
            <div>
                <label for="email" class="required_label">{{
                    $translate('public.contact.form.email')
                }}</label>
                <input
                    type="email"
                    id="email"
                    v-model="userInfos.email"
                    :class="{
                        inputIsInvalid: apiStore.$state.errors.email,
                    }"
                />
            </div>
            <div>
                <label for="phone">{{
                    $translate('public.contact.form.tel')
                }}</label>
                <input type="tel" id="phone" v-model="userInfos.phone" />
            </div>
            <div>
                <label for="message" class="required_label">{{
                    $translate('public.contact.form.message')
                }}</label>
                <textarea
                    id="message"
                    v-model="userInfos.message"
                    :class="{
                        inputIsInvalid: apiStore.$state.errors.message,
                    }"
                ></textarea>
            </div>
            <p>
                {{ $translate('public.contact.form.text-1') }}
                <span class="required_star"> * </span
                >{{ $translate('public.contact.form.text-2') }}
            </p>
            <primary-button
                type="button"
                @click="submitForm"
                :loading="formIsLoading"
                >{{ $translate('public.contact.form.submit') }}</primary-button
            >
        </form>
    </div>
</template>

<script setup>
import { useApiStore } from '@/js/stores/apiStore';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';

const apiStore = useApiStore();
const $router = useRouter();
const route = useRoute();
const formIsLoading = ref(false);

const props = defineProps({
    defaultInfo: {
        type: Object,
        default: () => ({
            firstname: '',
            lastname: '',
            companyName: '',
            email: '',
            phone: '',
            message: '',
        }),
    },
});

const userInfos = ref(props.defaultInfo);

const submitForm = () => {
    formIsLoading.value = true;
    apiStore
        .apiPost('/api/emails/contact', userInfos.value)
        .then(() => {
            formIsLoading.value = false;
            if (route.query.bikes_catalog_id) {
                $router.push({
                    name: 'thank-you-for-the-test-request',
                });
            } else {
                $router.push({
                    name: 'thank-you-for-contacting-us',
                });
            }
        })
        .catch(() => {
            formIsLoading.value = false;
        });
};
</script>
<style lang="scss" scoped>
@use '@/scss/variables' as vars;

.contact-form {
    flex: 2;
    padding: 2rem;

    h2 {
        margin-top: 0;
        text-align: center;
        text-transform: uppercase;
    }

    form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1rem;
        margin: 2rem auto;
        max-width: 800px;

        .form-group {
            display: flex;
            flex-direction: column;
        }

        Button {
            grid-column: 1 / -1;
            justify-self: center;
        }

        .required_star {
            color: vars.$redColor;
        }
    }
}

@media (max-width: vars.$largeBreakpoint) {
    .contact-form {
        padding: 1rem;
        h2 {
            margin-top: 1rem;
        }
        form {
            grid-template-columns: 1fr;
        }
    }
}
</style>
